!function(n) {
    n(jQuery);
}(function(n) {
    function e(n) {
        var _$e = 7.5625, t = 2.75;
        return n < 1 / t ? _$e * n * n : n < 2 / t ? _$e * (n -= 1.5 / t) * n + .75 : n < 2.5 / t ? _$e * (n -= 2.25 / t) * n + .9375 : _$e * (n -= 2.625 / t) * n + .984375;
    }
    n.easing.jswing = n.easing.swing;
    var t = Math.pow, u = Math.sqrt, r = Math.sin, i = Math.cos, a = Math.PI, c = 1.70158, o = 1.525 * c, s = 2 * a / 3, f = 2 * a / 4.5;
    n.extend(n.easing, {
        def: "easeOutQuad",
        swing: function swing(e) {
            return n.easing[n.easing.def](e);
        },
        easeInQuad: function easeInQuad(n) {
            return n * n;
        },
        easeOutQuad: function easeOutQuad(n) {
            return 1 - (1 - n) * (1 - n);
        },
        easeInOutQuad: function easeInOutQuad(n) {
            return n < .5 ? 2 * n * n : 1 - t(-2 * n + 2, 2) / 2;
        },
        easeInCubic: function easeInCubic(n) {
            return n * n * n;
        },
        easeOutCubic: function easeOutCubic(n) {
            return 1 - t(1 - n, 3);
        },
        easeInOutCubic: function easeInOutCubic(n) {
            return n < .5 ? 4 * n * n * n : 1 - t(-2 * n + 2, 3) / 2;
        },
        easeInQuart: function easeInQuart(n) {
            return n * n * n * n;
        },
        easeOutQuart: function easeOutQuart(n) {
            return 1 - t(1 - n, 4);
        },
        easeInOutQuart: function easeInOutQuart(n) {
            return n < .5 ? 8 * n * n * n * n : 1 - t(-2 * n + 2, 4) / 2;
        },
        easeInQuint: function easeInQuint(n) {
            return n * n * n * n * n;
        },
        easeOutQuint: function easeOutQuint(n) {
            return 1 - t(1 - n, 5);
        },
        easeInOutQuint: function easeInOutQuint(n) {
            return n < .5 ? 16 * n * n * n * n * n : 1 - t(-2 * n + 2, 5) / 2;
        },
        easeInSine: function easeInSine(n) {
            return 1 - i(n * a / 2);
        },
        easeOutSine: function easeOutSine(n) {
            return r(n * a / 2);
        },
        easeInOutSine: function easeInOutSine(n) {
            return -(i(a * n) - 1) / 2;
        },
        easeInExpo: function easeInExpo(n) {
            return 0 === n ? 0 : t(2, 10 * n - 10);
        },
        easeOutExpo: function easeOutExpo(n) {
            return 1 === n ? 1 : 1 - t(2, -10 * n);
        },
        easeInOutExpo: function easeInOutExpo(n) {
            return 0 === n ? 0 : 1 === n ? 1 : n < .5 ? t(2, 20 * n - 10) / 2 : (2 - t(2, -20 * n + 10)) / 2;
        },
        easeInCirc: function easeInCirc(n) {
            return 1 - u(1 - t(n, 2));
        },
        easeOutCirc: function easeOutCirc(n) {
            return u(1 - t(n - 1, 2));
        },
        easeInOutCirc: function easeInOutCirc(n) {
            return n < .5 ? (1 - u(1 - t(2 * n, 2))) / 2 : (u(1 - t(-2 * n + 2, 2)) + 1) / 2;
        },
        easeInElastic: function easeInElastic(n) {
            return 0 === n ? 0 : 1 === n ? 1 : -t(2, 10 * n - 10) * r((10 * n - 10.75) * s);
        },
        easeOutElastic: function easeOutElastic(n) {
            return 0 === n ? 0 : 1 === n ? 1 : t(2, -10 * n) * r((10 * n - .75) * s) + 1;
        },
        easeInOutElastic: function easeInOutElastic(n) {
            return 0 === n ? 0 : 1 === n ? 1 : n < .5 ? -(t(2, 20 * n - 10) * r((20 * n - 11.125) * f)) / 2 : t(2, -20 * n + 10) * r((20 * n - 11.125) * f) / 2 + 1;
        },
        easeInBack: function easeInBack(n) {
            return (c + 1) * n * n * n - c * n * n;
        },
        easeOutBack: function easeOutBack(n) {
            return 1 + (c + 1) * t(n - 1, 3) + c * t(n - 1, 2);
        },
        easeInOutBack: function easeInOutBack(n) {
            return n < .5 ? t(2 * n, 2) * (7.189819 * n - o) / 2 : (t(2 * n - 2, 2) * ((o + 1) * (2 * n - 2) + o) + 2) / 2;
        },
        easeInBounce: function easeInBounce(n) {
            return 1 - e(1 - n);
        },
        easeOutBounce: e,
        easeInOutBounce: function easeInOutBounce(n) {
            return n < .5 ? (1 - e(1 - 2 * n)) / 2 : (1 + e(2 * n - 1)) / 2;
        }
    });
});

//# sourceMappingURL=index.3d396705.js.map
